import VCSearchBusinessResults from "./VCSearchBusinessResults";

export default VCSearchBusinessResults;
